import axios from "axios";

export function formatMoney(amount) {
    amount = Math.round(amount);

    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "EUR",
    }).format(amount);
}

export function scrollToElementById(id, offset = 30) {
    setTimeout(function () {
        const element = document.getElementById(id);

        if (!element) {
            return;
        }

        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const headerHeight = document.querySelector('.site-header')?.offsetHeight || 0;

        window.scrollTo({
            top: rect.top + scrollTop - headerHeight - offset,
            behavior: "smooth"
        });
    }, 100);
}

export function internalApi() {
    return axios.create({
        baseURL: BSDC.apiBaseUrl,
    });
}

export async function externalApi() {
    try {
        const token = await internalApi().get('/token');

        return axios.create({
            baseURL: BSDC.externalApiBaseUrl,
            headers: {
                Authorization: `Bearer ${token.data?.token}`,
            },
        });
    } catch (error) {
        console.error('Failed to get API token:', error);

        throw new Error('Failed to initialize. Please refresh the page.');
    }
}

export function debounce(fn, wait = 0) {
    let timerId;

    function debounced(...args) {
        const context = this;

        clearTimeout(timerId);

        timerId = setTimeout(() => {
            fn.apply(context, args);
        }, Math.max(0, Number(wait) || 0));
    }

    debounced.cancel = () => {
        clearTimeout(timerId);
    };

    return debounced;
}

